<template>
    <ModalBase
        name="addAbonado"
        title="Añadir nuevo abonado"
        @close="() => close(false)"
    >
        <ValidationObserver ref="observer" tag="form" @submit.prevent="submit">
            <div class="tw:space-y-4">

                <BaseInputText
                    v-model="data.name"
                    label="Nombre"
                    name="name"
                    data-cy="nombre"
                    rules="required"
                />

                <BaseInputText
                    v-model="data.surnames"
                    label="Apellidos"
                    name="surnames"
                    data-cy="apellidos"
                    rules="required"
                />

                <BaseMultiselect
                    v-model="data.genero_id"
                    name="género"
                    data-cy="genero"
                    rules="required"
                    label="Género"
                    :options="generos"
                    value-key="id"
                    label-key="name"
                />

                <BaseInputText
                    v-model="data.dni"
                    label="DNI"
                    name="dni"
                    data-cy="dni"
                    rules="required"
                />

                <BaseInputText
                    v-if="mostrar_iban"
                    v-model="data.iban"
                    label="IBAN"
                    name="iban"
                    data-cy="iban"
                    rules="required"
                />

                <BaseInputText
                    v-if="mostrar_titular_cuenta"
                    v-model="data.titular_cuenta"
                    label="Titular de la cuenta"
                    name="titular_cuenta"
                    data-cy="titular-cuenta"
                    rules="required"
                />

                <BaseInputText
                    v-model="data.n_abonado"
                    label="Nº de abonado"
                    name="n_abonado"
                    data-cy="n-abonado"
                    rules="required"
                />

                <BaseInputText
                    v-model="data.n_abonado_antiguo"
                    label="Nº de abonado antiguo"
                    name="n_abonado_antiguo"
                    data-cy="n-abonado-antiguo"
                    rules="required"
                />

                <!-- Error del servidor -->
                <div
                    v-if="error"
                    class="tw:rounded-md tw:bg-red-50 tw:border tw:border-red-200 tw:p-3"
                >
                    <p class="tw:text-sm tw:text-red-700 tw:m-0">{{ error }}</p>
                </div>

                <!-- Botón -->
                <div class="tw:flex tw:justify-end tw:pt-2">
                    <Button
                        id="submit-add-abonado"
                        type="submit"
                        :disabled="loading"
                    >
                        Añadir
                    </Button>
                </div>

            </div>
        </ValidationObserver>
    </ModalBase>
</template>

<script setup>
    import { ref, reactive, computed } from 'vue'
    import store from '@/store'
    import { useToast } from '@/composables/common/useToast'
    import { config } from '@/config'
    import ModalBase from '@/modules/admin/ui/ModalBase'
    import BaseInputText from '@/modules/admin/ui/BaseInputText.vue'
    import BaseMultiselect from '@/modules/admin/ui/BaseMultiselect.vue'
    import Button from '@/modules/admin/ui/Button.vue'

    const props = defineProps({
        lista_abonado: {
            required: true,
            type: Object
        }
    })

    const emit = defineEmits(['close'])
    const toast = useToast()

    const data = reactive({})
    const loading = ref(false)
    const error = ref(null)
    const observer = ref(null)

    const mostrar_iban = computed(() => store.getters.getTeatro.mostrar_iban)
    const mostrar_titular_cuenta = computed(() => store.getters.getTeatro.mostrar_titular_cuenta)
    const generos = computed(() => store.getters.getGeneros)

    const close = actualizar => {
        Object.keys(data).forEach(key => delete data[key])
        emit('close', 'addAbonado', actualizar)
    }

    const crear = () => {
        loading.value = true

        data.filters = {}
        data.lista_abonado_id = props.lista_abonado.id

        store.dispatch(config.getVuexAlias('back.abonados.create'), data)
            .then(res => {
                loading.value = false
                toast.success('Abonado creado correctamente')
                close(true)
            })
            .catch(err => {
                error.value = err.response.data.message
                loading.value = false
            })
    }

    const submit = async() => {
        const isValid = await observer.value?.validate()
        if(isValid) {
            crear()
        }
    }
</script>
